/**
 * In-Store-Only Variant Hiding (v1)
 *
 * Reads the JSON data from #in-store-only-data (output by in-store-only-data.liquid)
 * and hides flagged variants from the product page:
 *   1. Hides option values (dropdown <option> or swatch radio) where ALL variants
 *      for that value are in-store-only.
 *   2. Disables in-store-only variants in the hidden variant <select>.
 *   3. If the default selected variant is in-store-only, selects the first visible one.
 *
 * Gallery image hiding is handled server-side by variant-media-hide.liquid (CSS).
 */
(function () {
  'use strict';

  function init() {
    // --- Read in-store-only data ---
    var isoDataEl = document.getElementById('in-store-only-data');
    if (!isoDataEl) return; // no in-store-only variants on this product

    var isoData;
    try {
      isoData = JSON.parse(isoDataEl.textContent);
    } catch (e) {
      return;
    }
    if (!isoData.variantIds || !isoData.variantIds.length) return;

    var isoSet = {};
    isoData.variantIds.forEach(function (id) {
      isoSet[String(id)] = true;
    });

    // --- Read product data from Empire's section JSON ---
    var sectionDataEl = document.querySelector(
      'script[data-section-type="static-product"][data-section-data]'
    );
    if (!sectionDataEl) return;

    var sectionData;
    try {
      sectionData = JSON.parse(sectionDataEl.textContent);
    } catch (e) {
      return;
    }

    var product = sectionData.product;
    if (!product || !product.variants) return;

    // --- Build option-value counts ---
    // For each option position, track how many total variants and how many
    // in-store-only variants use each value. If all variants for a value
    // are in-store-only, that value should be hidden.
    var optionCount = product.options.length;
    var valueCounts = []; // valueCounts[optionIndex][value] = { total, iso }

    for (var i = 0; i < optionCount; i++) {
      valueCounts.push({});
    }

    product.variants.forEach(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      var isIso = isoSet[String(v.id)] === true;

      for (var i = 0; i < optionCount; i++) {
        var val = opts[i];
        if (val == null) continue;
        if (!valueCounts[i][val]) {
          valueCounts[i][val] = { total: 0, iso: 0 };
        }
        valueCounts[i][val].total++;
        if (isIso) valueCounts[i][val].iso++;
      }
    });

    // Build sets of values to hide per option index
    var hideValues = [];
    for (var i = 0; i < optionCount; i++) {
      var hidden = {};
      var keys = Object.keys(valueCounts[i]);
      for (var k = 0; k < keys.length; k++) {
        var val = keys[k];
        var counts = valueCounts[i][val];
        if (counts.iso === counts.total) {
          hidden[val] = true;
        }
      }
      hideValues.push(hidden);
    }

    // --- Hide dropdown <option> elements ---
    var optionSelects = document.querySelectorAll(
      'select.options-selection__input-select'
    );
    optionSelects.forEach(function (sel, idx) {
      if (idx >= optionCount) return;
      var options = sel.querySelectorAll('option[data-variant-option-value]');
      options.forEach(function (opt) {
        if (hideValues[idx][opt.value]) {
          opt.style.display = 'none';
          opt.disabled = true;
        }
      });
    });

    // --- Hide swatch/radio option values ---
    var optionGroups = document.querySelectorAll(
      '[data-variant-option-index]'
    );
    // For swatches/radios, the wrapper is .options-selection__option-value
    // containing an input with the value
    var radioWrappers = document.querySelectorAll(
      '.options-selection__option-value'
    );
    radioWrappers.forEach(function (wrapper) {
      var input = wrapper.querySelector(
        'input.options-selection__option-value-input'
      );
      if (!input) return;
      // Determine which option index this belongs to
      var parent = wrapper.closest('[data-variant-option-index]');
      if (!parent) return;
      var idx = parseInt(parent.getAttribute('data-variant-option-index'), 10);
      if (isNaN(idx) || idx >= optionCount) return;

      if (hideValues[idx][input.value]) {
        wrapper.style.display = 'none';
        input.disabled = true;
      }
    });

    // --- Disable in-store-only variants in the hidden variant <select> ---
    var variantSelect = document.querySelector('select.variant-selection__variants');
    if (variantSelect) {
      var variantOptions = variantSelect.querySelectorAll('option');
      variantOptions.forEach(function (opt) {
        if (isoSet[opt.value]) {
          opt.disabled = true;
        }
      });
    }

    // --- Fix default selection if current variant is in-store-only ---
    var currentVariantId = variantSelect ? variantSelect.value : null;
    if (currentVariantId && isoSet[currentVariantId]) {
      // Find first non-ISO variant
      var firstVisible = null;
      for (var v = 0; v < product.variants.length; v++) {
        if (!isoSet[String(product.variants[v].id)]) {
          firstVisible = product.variants[v];
          break;
        }
      }

      if (firstVisible) {
        // Update hidden variant select
        if (variantSelect) {
          variantSelect.value = String(firstVisible.id);
        }

        // Update visible option selectors
        var opts = [firstVisible.option1, firstVisible.option2, firstVisible.option3];
        var lastSelect = null;

        // Update dropdowns
        optionSelects.forEach(function (sel, idx) {
          if (idx < optionCount && opts[idx] != null) {
            sel.value = opts[idx];
            // Update the chosen-value data attribute
            sel.setAttribute('data-variant-option-chosen-value', opts[idx]);
            lastSelect = sel;
          }
        });

        // Update radio/swatch inputs
        radioWrappers.forEach(function (wrapper) {
          var input = wrapper.querySelector(
            'input.options-selection__option-value-input'
          );
          if (!input) return;
          var parent = wrapper.closest('[data-variant-option-index]');
          if (!parent) return;
          var idx = parseInt(parent.getAttribute('data-variant-option-index'), 10);
          if (isNaN(idx) || idx >= optionCount) return;
          if (opts[idx] != null) {
            input.checked = (input.value === opts[idx]);
          }
        });

        // Dispatch change to trigger Empire's variant selection update
        if (lastSelect) {
          lastSelect.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          // For radio/swatch, find the checked input and dispatch
          var checkedInput = document.querySelector(
            'input.options-selection__option-value-input:checked'
          );
          if (checkedInput) {
            checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        // Persistent click handler: re-clicking the selected swatch navigates to its image.
        // Normally clicking an already-checked radio doesn't fire 'change', so Empire
        // won't slide the gallery. This handler fills that gap.
        var firstVisiblePos = firstVisible.featured_image
          ? firstVisible.featured_image.position
          : null;

        if (firstVisiblePos) {
          var checkedWrapper = document.querySelector(
            '.options-selection__option-value:has(input.options-selection__option-value-input:checked)'
          );
          if (checkedWrapper) {
            checkedWrapper.addEventListener('click', function() {
              var inp = checkedWrapper.querySelector('input');
              if (inp && inp.checked) {
                var viewerEl = document.querySelector('.product-gallery__viewer');
                if (viewerEl && viewerEl.swiper) {
                  viewerEl.swiper.slideTo(firstVisiblePos - 1, 0);
                }
              }
            });
          }
        }
      }
    }
  }

  // Poll for DOM readiness (same pattern as variant-gallery-sync.js)
  var attempts = 0;
  var maxAttempts = 50;
  var timer = setInterval(function () {
    attempts++;
    var result = init();
    if (result !== false || attempts >= maxAttempts) {
      clearInterval(timer);
    }
  }, 100);
})();
